// Language Selector Component
// Grid of available languages for user selection

import { Globe, Loader2 } from 'lucide-react';
import { AVAILABLE_LANGUAGES } from './chatConstants';

const LanguageSelector = ({ 
  onLanguageSelect, 
  getSavedLanguagePreference, 
  loadingTranslations, 
  detectedLanguageName 
}) => {
  if (loadingTranslations) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center">
          <Loader2 className="w-8 h-8 text-teal-500 animate-spin mx-auto mb-2" />
          <p className="text-sm text-slate-600">Loading {detectedLanguageName}...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 border-b border-slate-100">
      <div className="text-center mb-3">
        <Globe className="w-8 h-8 text-teal-500 mx-auto mb-2" />
        <h4 className="font-semibold text-slate-800 text-sm">Choose Your Language</h4>
        <p className="text-xs text-slate-500">Select your preferred language to continue</p>
        <p className="text-[10px] text-slate-400 mt-1">30 languages supported</p>
      </div>
      <div className="grid grid-cols-3 gap-2 max-h-64 overflow-y-auto pr-1">
        {AVAILABLE_LANGUAGES.map((lang) => {
          const savedPref = getSavedLanguagePreference();
          const isRemembered = savedPref?.code === lang.code;
          return (
            <button
              key={lang.code}
              onClick={() => onLanguageSelect(lang.code, lang.name)}
              className={`p-2 text-xs rounded-lg border transition-colors text-center ${
                isRemembered 
                  ? 'border-teal-400 bg-teal-50 ring-2 ring-teal-200' 
                  : 'border-slate-200 hover:border-teal-400 hover:bg-teal-50'
              }`}
              data-testid={`lang-select-${lang.code}`}
            >
              <span className="block font-medium text-slate-700">{lang.native}</span>
              <span className="block text-slate-400 text-[10px]">{lang.name}</span>
              {isRemembered && (
                <span className="block text-teal-600 text-[9px] mt-0.5">★ Remembered</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LanguageSelector;
